import React from 'react'
import Help from '~/Common-Objects/Logos/help'
import { Tooltip } from 'react-tooltip'

export default class HeaderText extends React.Component {
    render() {
        if (this.props.tooltip) {
            return <h4 className={"page-title " + this.props.className} style={this.props.style}>{this.props.children} <span>
                <Help title="help" width="16px" data-tooltip-content={this.props.tooltip} data-tooltip-id={'header' + this.props.for} /></span>
                <Tooltip className={"tooltip " + this.props.className} id={'header' + this.props.for} />
            </h4>
        } else {
            return <h4 className={"page-title " + this.props.className} style={this.props.style}>{this.props.children}</h4>
        }

    }
}
